import { userRoles } from './user.constants';

export const roleOptions = [
  { label: 'Admin', value: userRoles.admin },
  { label: 'User', value: userRoles.user },
  { label: 'Trainee', value: userRoles.trainee },
];
